
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/page/[idx]",
      function () {
        return require("private-next-pages/blog/page/[idx].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/page/[idx]"])
      });
    }
  